import * as moment from 'moment';
import { FormControl, Button, Panel, Form, Row, Col, FormGroup, ControlLabel, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import MaskedInput from "react-maskedinput";
import MediaQuery from 'react-responsive';
import { FilterWrapper } from './styles';
import { ISerologySearchRequest, IListItem } from '@nkr/models/index';
import { SerologyListType } from '@nkr/store/index';

interface IProps {
    centerId: number,
    data: ISerologySearchRequest,
    statusList: IListItem[],
    centerList: IListItem[],
    listType: SerologyListType,
    onChange: (field: string, value: any) => void,
    onChangeType: (listType: number) => void,
    onClearGrid: () => void,
    onSearch: () => void,
}

const Filters = (props: IProps) => {
    const handleFieldChange = (field: string, value: string) => {
        props.onChange(field, value);
    };

    const handleToggleButtonFieldChange = (field: string, value: number) => {
        props.onChange(field, value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<FormControl & HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    const handleSearch = () => {
        props.onSearch();
    }

    const handleClear = () => {
        props.onClearGrid();
    };

    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div><h4>Serology Tracking</h4></div>
                </div>

                {props.centerId > 0 ?
                    <>
                        <FilterWrapper bsSize='sm'>
                            <Row>
                                <Col xs={12}>
                                    <Form inline style={{ textAlign: 'left', float: 'left' }}  >
                                        <FormGroup bsSize='sm' style={{ marginRight: '500' }}>
                                            <ControlLabel>Filter by Status:</ControlLabel>{' '}
                                            <FormControl
                                                componentClass='select'
                                                value={props.listType}
                                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onChangeType(parseInt(e.currentTarget.value))}
                                            >
                                                <option value={-1}>- ALL -</option>
                                                {props.statusList.map(item =>
                                                    <option value={item.id}>{item.description}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                        </FilterWrapper>
                    </>
                    :
                    <FilterWrapper bsSize='sm'>
                        <Row>
                            <Col xs={12}>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <Panel>
                                        <Panel.Body>
                                            <Form horizontal style={{ border: 'none' }}>
                                                <Row>
                                                    <Col xs={12} lg={5}>
                                                        <FormGroup bsSize='sm'>
                                                            <Col xs={4} componentClass={ControlLabel}>Filter on Date?:&nbsp;</Col>
                                                            <Col xs={8}>
                                                                <ToggleButtonGroup type='radio' name='dateStatus' value={props.data.dateStatus}>
                                                                    <ToggleButton value={0} className={props.data.dateStatus == 0 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleToggleButtonFieldChange('dateStatus', 0)}>Requested&nbsp;</ToggleButton>
                                                                    <ToggleButton value={1} className={props.data.dateStatus == 1 ? 'btn-primary btn-sm' : 'btn-default btn-sm'} onClick={() => handleToggleButtonFieldChange('dateStatus', 1)}>Deadline&nbsp;</ToggleButton>
                                                                </ToggleButtonGroup>
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col xs={12} lg={3}>
                                                        <FormGroup bsSize='sm'>
                                                            <Col xs={3} componentClass={ControlLabel}>From:&nbsp;</Col>
                                                            <Col xs={9}>
                                                                <MaskedInput
                                                                    name='filterStartDate'
                                                                    className='form-control form-control-sm'
                                                                    style={{ width: 105 }}
                                                                    mask={'11/11/1111'}
                                                                    value={moment(props.data.filterStartDate).format('MM/DD/YYYY')}
                                                                    onKeyDown={handleKeyDown}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => handleFieldChange('filterStartDate', e.currentTarget.value)}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col xs={12} lg={4}>
                                                        <FormGroup bsSize='sm'>
                                                            <Col xs={3} componentClass={ControlLabel}>Until:&nbsp;</Col>
                                                            <Col xs={9}>
                                                                <MaskedInput
                                                                    name='filterEndDate'
                                                                    className='form-control'
                                                                    style={{ width: 105 }}
                                                                    mask={'11/11/1111'}
                                                                    value={moment(props.data.filterEndDate).format('MM/DD/YYYY')}
                                                                    onKeyDown={handleKeyDown}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => handleFieldChange('filterEndDate', e.currentTarget.value)}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} lg={4}>
                                                        <FormGroup bsSize='sm'>
                                                            <Col xs={3} componentClass={ControlLabel}>Center: &nbsp;</Col>
                                                            <Col xs={9}>
                                                                <FormControl
                                                                    componentClass='select'
                                                                    bsSize='sm'
                                                                    value={props.data.centerId}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => handleFieldChange('centerId', e.currentTarget.value)}
                                                                    style={{ width: '70%' }}
                                                                >
                                                                    <option value={-1}>- All Centers -</option>
                                                                    {props.centerList.map((item, index) =>
                                                                        <option key={'cent-' + index} value={item.id}>{item.description}</option>
                                                                    )}
                                                                </FormControl>
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={12} lg={4}>
                                                        <FormGroup bsSize='sm'>
                                                            <Col xs={3} componentClass={ControlLabel}>Status: &nbsp;</Col>
                                                            <Col xs={9}>
                                                                <FormControl
                                                                    componentClass='select'
                                                                    value={props.data.serologyStatus}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => handleFieldChange('serologyStatus', e.currentTarget.value)}
                                                                >
                                                                    <option value={-1}>- ALL -</option>
                                                                    {props.statusList.map(item =>
                                                                        <option value={item.id}>{item.description}</option>
                                                                    )}
                                                                </FormControl>

                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Panel.Body>
                                    </Panel>
                                </div>
                            </Col>

                            <div className="col-xs-12">
                                <MediaQuery minDeviceWidth={1878}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ width: 150, marginRight: 5 }}>
                                            <Button className='btn-block' bsStyle="primary" onClick={handleSearch}>Search</Button>
                                        </div>

                                        <div style={{ width: 150, marginRight: 5 }}>
                                            <Button className='btn-block' onClick={handleClear}>Clear Filters</Button>
                                        </div>
                                    </div>
                                </MediaQuery>

                                <MediaQuery maxDeviceWidth={1877}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ width: 150, marginRight: 5 }}>
                                            <Button className='btn-block btn-sm' bsStyle="primary" onClick={handleSearch}>Search</Button>
                                        </div>
                                    </div>
                                </MediaQuery>
                            </div>
                        </Row>
                    </FilterWrapper>
                }
            </div>
        </>
    );
}

export default Filters;